import React, { useState, useEffect, useContext } from "react";
import { Input, Tabs, Select, DatePicker } from "antd";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import AuthorizationError from "../../AuthorizationError";
import PendingTab from "./PendingTab";
import mainContext from "../context/MainContext/mainContext";
import { setSideTab } from "../../../../toolkit/slices/inventories/inventorySlice";
import accessCheckPromise from "../../../../../utils/accessCheck";
import { logoutUser } from "../../../../toolkit/slices/users/userSlice";
import InvoiceBillingDetails from "./InvoiceBillingDetails";
import CompletedTab from "./CompletedTab";
import Einvoices from "./Einvoices";
import GeneratedCreditNotes from "./GeneratedCreditNotes";
import { getFinancialYearOptions } from "../../ReportContainer/utils/financialYearUtils";
const { Search } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const BillingContainer = () => {
  let userId = useSelector((state) => state.user._id);
  const dispatch = useDispatch();
  const {
    id,
    totalInvoices,
    billingInvoiceIds,
    billingInvoices,
    searchQuery,
    setSearchQuery,
    setFetchToggle,
    setPageNumber,
    fetchPartiesAndBrands,
    parties,
    brands,
    createdByFilter,
    setCreatedByFilter,
    campaignDateRange,
    setCampaignDateRange,
    salesPersonFilter,
    setSalesPersonFilter,
    salesPersonOptions,
    salesPersonLoading,
    financialYear,
    setFinancialYear,
  } = useContext(mainContext);
  const [access, setAccess] = useState(true);
  const [filtersBDF, setFiltersBDF] = useState({
    client: null,
    createdBy: null,
    dateRange: null,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get("tab") || "1");
  const [activeSubTab, setActiveSubTab] = useState("invoice-1");
  const [baseTab, setBaseTab] = useState(
    searchParams.get("tab") === "2" ? "2" : "1"
  );
  const [partySearchText, setPartySearchText] = useState("");
  const [brandSearchText, setBrandSearchText] = useState("");
  const [anySearchText, setAnySearchText] = useState("");
  const [activeSearchMode, setActiveSearchMode] = useState(null); // "party" | "brand" | "any" | null

  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  console.log("totalInvoices are: ", totalInvoices);

  useEffect(() => {
    // Synchronize the activeTab state with the URL parameter
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "1" });
    } else {
      setActiveTab(searchParams.get("tab"));
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (activeTab === "1") {
      fetchPartiesAndBrands("pending");
    } else if (activeTab === "2") {
      fetchPartiesAndBrands("completed");
    } else if (activeTab === "4") {
      fetchPartiesAndBrands("e-invoice");
    }
  }, [activeTab]);

  useEffect(() => {
    // Media Planner filter disabled; no need to fetch salesmen list here.
  }, [activeTab]);

  // Sales persons list is fetched once in context.

  let tabs = [];

  const currentTab = searchParams.get("tab");

  if (!id) {
    tabs = [
      { key: "1", label: "Pending" },
      { key: "2", label: "Completed" },
      { key: "4", label: "E-Invoices" },
      { key: "5", label: "Credit Notes" },
    ];
  } else {
    if (currentTab === "1") {
      tabs = [{ key: "1", label: "Pending" }];
    } else if (currentTab === "2") {
      tabs = [{ key: "2", label: "Completed" }];
    } else if (currentTab === "3") {
      if (baseTab === "1") {
        tabs = [{ key: "1", label: "Pending" }];
      } else {
        tabs = [{ key: "2", label: "Completed" }];
      }
    }
  }

  if (id && totalInvoices > 0) {
    tabs.push({
      key: "3", // Assigning "3" to Sub Invoice for future-proofing
      label: "Billing History",
    });
  }

  const tabChange = (key) => {
    handleClearFilters();
    setPageNumber(1);
    setActiveTab(key);
    setSearchParams({ tab: key });

    if (key === "1" || key === "2") {
      setBaseTab(key); // Track where the user was
    }

    if (key === "3") {
      // setActiveSubTab("invoice-1");

      // Set the last invoice as the default active sub-tab
      const lastInvoiceIndex = billingInvoiceIds.length; // Get the last invoice index
      setActiveSubTab(`invoice-${lastInvoiceIndex}`);
    }
  };

  const subTabChange = (key) => {
    setActiveSubTab(key);
  };

  const applyPartySearch = (value) => {
    const next = value ?? "";
    setPartySearchText(next);
    setSearchQuery(next);
    setBrandSearchText("");
    setAnySearchText("");
    setActiveSearchMode("party");
    setFetchToggle((prev) => !prev);
  };

  const applyBrandSearch = (value) => {
    const next = value ?? "";
    setBrandSearchText(next);
    setSearchQuery(next);
    setPartySearchText("");
    setAnySearchText("");
    setActiveSearchMode("brand");
    setFetchToggle((prev) => !prev);
  };

  const applyAnySearch = (value) => {
    const next = value ?? "";
    setAnySearchText(next);
    setSearchQuery(next);
    setPartySearchText("");
    setBrandSearchText("");
    setActiveSearchMode("any");
    setFetchToggle((prev) => !prev);
  };

  const handlePartySelectChange = (val) => {
    const next = val ?? "";
    if (!next) {
      setPartySearchText("");
      if (activeSearchMode === "party") {
        setSearchQuery("");
        setActiveSearchMode(null);
        setFetchToggle((prev) => !prev);
      }
      return;
    }
    applyPartySearch(next);
  };

  const handleBrandSelectChange = (val) => {
    const next = val ?? "";
    if (!next) {
      setBrandSearchText("");
      if (activeSearchMode === "brand") {
        setSearchQuery("");
        setActiveSearchMode(null);
        setFetchToggle((prev) => !prev);
      }
      return;
    }
    applyBrandSearch(next);
  };

  // const generateSubTabs = () => {
  //   return billingInvoiceIds.map((invoiceId, index) => ({
  //     key: `invoice-${index + 1}`,
  //     label: `Invoice ${index + 1}`,
  //   }));
  // };

  const formatCreatedAt = (createdAt) => {
    if (!createdAt) return "";
    const d = new Date(createdAt);
    return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  };

  // Reverse the order of billingInvoiceIds for tabs 3, 2, 1
  const generateSubTabs = () => {
    const list = billingInvoices?.length ? billingInvoices : billingInvoiceIds.map((id) => ({ _id: id }));
    return list
      .slice()
      .reverse()
      .map((invoice, index) => {
        const n = list.length - index;
        const dateStr = invoice.createdAt ? formatCreatedAt(invoice.createdAt) : "";
        return {
          key: `invoice-${n}`,
          label: dateStr ? `Invoice ${n} | ${dateStr}` : `Invoice ${n}`,
        };
      });
  };

  console.log("billingInvoiceIds are: ", billingInvoiceIds);

  const renderTabContent = () => {
    if (activeTab === "1") {
      return <PendingTab />;
    }

    if (activeTab === "2") {
      return <CompletedTab />;
    }

    if (activeTab === "3") {
      // Extract sub-tab index (e.g., "invoice-3" → index 2)
      const subTabIndex = parseInt(activeSubTab.split("-")[1], 10) - 1;
      const selectedInvoiceId = billingInvoiceIds[subTabIndex] || null;

      return (
        <>
          <Tabs
            activeKey={activeSubTab}
            onChange={subTabChange}
            type="card"
            items={generateSubTabs()}
          />
          {selectedInvoiceId ? (
            <InvoiceBillingDetails invoiceId={selectedInvoiceId} />
          ) : (
            <div>No invoice found!</div>
          )}
        </>
      );
    }
    if (activeTab === "4") {
      return (
        <>
          <Einvoices setParentTab={setActiveTab} />
        </>
      );
    }
    if (activeTab === "5") {
      return (
        <>
          <GeneratedCreditNotes />
        </>
      );
    }

    return null;
  };

  const [dates, setDates] = useState(null);

  const handleClearFilters = () => {
    setDates(null);
    setFiltersBDF({
      client: null,
      createdBy: null,
      dateRange: null,
    });
    if (createdByFilter) {
      setCreatedByFilter(null);
      setFetchToggle((prev) => !prev);
    }
    if (salesPersonFilter) {
      setSalesPersonFilter(null);
      setFetchToggle((prev) => !prev);
    }
    if (campaignDateRange) {
      setCampaignDateRange(null);
      setFetchToggle((prev) => !prev);
    }
  };

  if (!access) {
    return <AuthorizationError />;
  }
  return (
    <div
      className="parent-padding-container"
      style={{
        backgroundColor: "white",
        borderRadius: "12px",
        padding: "0px 20px",
      }}
    >
      <div
        style={{
          // backgroundColor: "white",
          padding: "0px 20px",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "1rem",
        }}
      >
        <Tabs
          defaultActiveKey="1"
          activeKey={activeTab}
          onChange={tabChange}
          items={tabs}
        />
        {(activeTab === "1" || activeTab === "2" || activeTab === "4" || activeTab === "5") &&
          !id && (
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            {activeTab === "5" ? (
              <Select
                value={financialYear}
                onChange={(fy) => {
                  setFinancialYear(fy);
                  setPageNumber(1);
                }}
                style={{ width: 120 }}
                placeholder="Financial Year"
              >
                {getFinancialYearOptions().map((fy) => (
                  <Option key={fy} value={fy}>
                    {fy}
                  </Option>
                ))}
              </Select>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                {/* Row 1: Sales person, party, brand */}
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flexWrap: "wrap",
                    marginTop: 6,
                  }}
                >
                  {(activeTab === "1" || activeTab === "2") && (
                    <Select
                      placeholder="Select Sales Person"
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) => {
                        const label = String(option?.label ?? "").toLowerCase();
                        const query = String(input ?? "").toLowerCase();
                        if (!query) return true;
                        return label.startsWith(query);
                      }}
                      value={salesPersonFilter || undefined}
                      onChange={(val) => {
                        const next = val ?? null;
                        setSalesPersonFilter(next);
                        setPageNumber(1);
                        setFetchToggle((p) => !p);
                      }}
                      style={{ width: 190 }}
                      loading={salesPersonLoading}
                      options={salesPersonOptions}
                    />
                  )}

                  {(activeTab === "1" || activeTab === "2") && (
                    // Media Planner filter disabled
                    null
                  )}

                  <Select
                    placeholder="Search by Party Name"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) => {
                      const label = String(option?.label ?? "").toLowerCase();
                      const query = String(input ?? "").toLowerCase();
                      if (!query) return true;
                      return label.startsWith(query);
                    }}
                    value={partySearchText || undefined}
                    onChange={handlePartySelectChange}
                    style={{ width: 240 }}
                    options={(parties || []).map((name) => ({
                      label: name,
                      value: name,
                    }))}
                  />

                  <Select
                    placeholder="Search by Brand Name"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) => {
                      const label = String(option?.label ?? "").toLowerCase();
                      const query = String(input ?? "").toLowerCase();
                      if (!query) return true;
                      return label.startsWith(query);
                    }}
                    value={brandSearchText || undefined}
                    onChange={handleBrandSelectChange}
                    style={{ width: 240 }}
                    options={(brands || []).map((name) => ({
                      label: name,
                      value: name,
                    }))}
                  />
                </div>

                {/* Row 2: SO/Bill search, then financial year */}
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    flexWrap: "wrap",
                    justifyContent: "flex-end",
                  }}
                >
                  {(activeTab === "1" || activeTab === "2") && (
                    <RangePicker
                      value={campaignDateRange}
                      onChange={(val) => {
                        setCampaignDateRange(val ?? null);
                        setPageNumber(1);
                        setFetchToggle((p) => !p);
                      }}
                      format="DD-MM-YYYY"
                      allowClear
                      style={{ width: 280 }}
                      placeholder={["Campaign Start", "Campaign End"]}
                    />
                  )}
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Search
                      placeholder="Search by SO/Bill No."
                      value={anySearchText}
                      onChange={(e) => {
                        const next = e.target.value;
                        const prev = anySearchText;
                        setAnySearchText(next);

                        // If user manually clears the field, reset filter + refetch
                        if (!next && prev && activeSearchMode === "any") {
                          setSearchQuery("");
                          setActiveSearchMode(null);
                          setFetchToggle((p) => !p);
                        }
                      }}
                      onSearch={() => {
                        if (!anySearchText.trim()) return;
                        applyAnySearch(anySearchText);
                      }}
                      style={{ width: 200 }}
                    />

                    {anySearchText && (
                      <button
                        type="button"
                        onClick={() => {
                          setAnySearchText("");
                          if (activeSearchMode === "any" || searchQuery) {
                            setSearchQuery("");
                            setActiveSearchMode(null);
                            setFetchToggle((prev) => !prev);
                          }
                        }}
                        style={{
                          background: "transparent",
                          border: "none",
                          cursor: "pointer",
                          fontSize: "16px",
                          lineHeight: 1,
                          padding: 0,
                          color: "#ff4d4f",
                        }}
                        aria-label="Clear SO/Bill No. filter"
                        title="Clear"
                      >
                        ❌
                      </button>
                    )}
                  </div>

                  <Select
                    value={financialYear}
                    onChange={(fy) => {
                      setFinancialYear(fy);
                      setPageNumber(1);
                    }}
                    style={{ width: 120 }}
                    placeholder="Financial Year"
                  >
                    {getFinancialYearOptions().map((fy) => (
                      <Option key={fy} value={fy}>
                        {fy}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      {renderTabContent()}
    </div>
  );
};

export default BillingContainer;
